
import Vue from 'vue'
import moment from 'moment'
import Tools from '@/tools/tools.js'

export default {
  namespaced: true,
  state: {
      lista: [],
      dt1: Tools.getDataAtual(),// moment().format('YYYY-MM-DD'),
      dt2: Tools.getDataAtual(), //moment().format('YYYY-MM-DD'),
      id: null,
      gta: null,
      clienteId: null,
      responsavelId : null,
      marchanteId: null,
      fazendaId: null,
      tipoProcesso: '0',
      tipoStatus: ['0','1','2','3','4','5','6','7'],
      registroSelecionadoId: null,
      paginaAtual: 1
  },
  getters: {
    LISTA: state => {
        return state.lista
    },
    DT1: state => {
        return state.dt1
    },
    DT2: state => {
        return state.dt2
    },
    ID: state => {
        return state.id
    },
    CLIENTE_ID: state => {
        return state.clienteId
    },
    RESPONSAVEL_ID: state => {
        return state.responsavelId
    },
    MARCHANTE_ID: state => {
        return state.marchanteId
    },
    FAZENDA_ID: state => {
        return state.fazendaId
    },
    GTA: state => {
        return state.gta
    },
    TIPO_PROCESSO: state => {
        return state.tipoProcesso
    },
    TIPO_STATUS: state => {
        return state.tipoStatus
    },
    REGISTRO_SELECIONADO_ID: state => {
        return state.registroSelecionadoId
    },
    PAGINA_ATUAL: state => {
        return state.paginaAtual
    }
  },
  /** MUTACOES SAO SINCRONAS - SEMELHANTES AO COMPUTED */
  mutations: {
      SET_LISTA: (state, payload) => {
          state.lista = payload
      },
      SET_DT1: (state, payload) => {
          state.dt1 = payload
      },
      SET_DT2: (state, payload) => {
          state.dt2 = payload
      },
      SET_ID: (state, payload) => {
          state.id = payload
      },
      SET_CLIENTE_ID: (state, payload) => {
          state.clienteId = payload
      },
      SET_FAZENDA_ID: (state, payload) => {
        state.fazendaId = payload
      },
      SET_MARCHANTE_ID: (state, payload) => {
        state.marchanteId = payload
      },
      SET_RESPONSAVEL_ID: (state, payload) => {
        state.responsavelId = payload
      },
      SET_GTA: (state, payload) => {
          state.gta = payload
      },
      SET_TIPO_PROCESSO: (state, payload) => {
          state.tipoProcesso = payload
      },
      SET_TIPO_STATUS: (state, payload) => {
          state.tipoStatus = payload
      },
      SET_REGISTRO_SELECIONADO_ID: (state, payload) => {
          state.registroSelecionadoId = payload
      },
      SET_PAGINA_ATUAL: (state, payload) => {
          state.paginaAtual = payload
      },
      SET_LIMPAR: (state, payload) => {
        state.lista = []
        state.dt1 = moment().format('YYYY-MM-DD')
        state.dt2 = moment().format('YYYY-MM-DD')
        state.id = null
        state.pedido = null
        state.clienteId = null
        state.responsavelId = null,
        state.marchanteId = null,
        state.fazendaId = null,
        state.tipoProcesso = ''
        state.tipoStatus = []
      }
  },
  /** ACTOINS SAO ASSINCRONOS */
  actions: {
    GERAR_LISTA: async ({ commit, getters}) => {
      let id = (getters.ID !== null ? getters.ID : '')
      let clienteId = (getters.CLIENTE_ID !== null ? getters.CLIENTE_ID : '')
      let marchanteId = (getters.MARCHANTE_ID !== null ? getters.MARCHANTE_ID : '')
      let fazendaId = (getters.FAZENDA_ID !== null ? getters.FAZENDA_ID : '')
      let responsavelId = (getters.RESPONSAVEL_ID !== null ? getters.RESPONSAVEL_ID : '')
      let gta = (getters.GTA !== null ? getters.GTA : '')
      let tipoProcesso = (getters.TIPO_PROCESSO !== null ? getters.TIPO_PROCESSO : '')
      let dt1 = (getters.DT1 !== null ? getters.DT1 : '')
      let dt2 = (getters.DT2 !== null ? getters.DT2 : '')
      let tipoStatus  = (getters.TIPO_STATUS !== null ? getters.TIPO_STATUS : [])
      
      let uri = `/api/protected/producao/pesquisar?id=${id}&dt1=${dt1}`+
                `&dt2=${dt2}`
        if (tipoProcesso) {
        uri += `&tipoProcesso=${tipoProcesso}`
        } 
        if (clienteId) {
        uri += `&clienteId=${clienteId}`
        }
        
        if (marchanteId) {
        uri += `&marchanteId=${marchanteId}`
        }
        if (fazendaId) {
        uri += `&fazendaId=${fazendaId}`
        }
        if (responsavelId) {
        uri += `&responsavelId=${responsavelId}`
        }
        if (gta) {
        uri += `&gta=${gta}`
        }
                  
        if (tipoStatus.length > 0 ) {
        
        let statusSelecao = ''
        let tem = false
        tipoStatus.forEach(e => {
          if (tem) {
            statusSelecao += '-' + e
          } else {
            statusSelecao += e
            tem = true
          }
        })
        uri += `&status=${statusSelecao}`
        }
        try {
          let data = await Vue.axios.get(uri)
          commit("SET_LISTA", data.data)
        } catch (err) {
          commit("SET_LISTA", {})
        }
      },
  }
}


// WEBPACK FOOTER //
// ./src/vuex/modulos/ordem-abate-store.js